import { ModalAnalysisData } from './keyword-item';

export class RuleAnalyticData {
  id: number;
  oneWordList: Array<string>;
  twoWordList: Array<string>;
  modalRequirements: Array<ModalAnalysisData>;
  mapCustomKeys: Array<string>;
  gaps: Array<string>;
  comments: Array<string>;
  policy: string;
  policySection: string;
  policySubSection: string;
  rulebookId: number;
  rulebookIdList: Array<number>;

  constructor() {
    this.id = 0;
    this.oneWordList = [];
    this.twoWordList = [];
    this.modalRequirements = [];
    this.mapCustomKeys = [];
    this.gaps = [];
    this.comments = [];
    this.policy = '';
    this.policySection = '';
    this.policySubSection = '';
    this.rulebookId = 0;
    this.rulebookIdList = [];
  }
}

export class RuleAnalytic {
  id: number;
  rulebookId: number;
  oneWord: string;
  twoWord: string;
  modalRequirements: string;
  mapCustomKeys: string;
  gap: string;
  comment: string;
  policyName: string;
  policySection: string;
  policySubSection: string;
  userId: number;

  constructor() {
    this.id = 0;
    this.rulebookId = 0;
    this.oneWord = '';
    this.twoWord = '';
    this.modalRequirements = '';
    this.mapCustomKeys = '';
    this.gap = '';
    this.comment = '';
    this.policyName = '';
    this.policySection = '';
    this.policySubSection = '';
    this.userId = 0;
  }
}
